<template>
    <router-link
        to="/central-messaging/clinicians/conversation"
        :class="`text-body ${shakeMessageIcon ? 'shake-less' : ''}`"
        data-bs-toggle="collapse"
        data-bs-target="#App_Menu"
        @click="onUnreadMessages"
    >
        <i
            class="fab fa-facebook-messenger"
            :class="[isAxxessPlannerHeader ? 'text-white' : 'text-dark']"
            title="Unread Messages"
        ></i>
        <sup
            ><span class="badge bg-primary px-1" v-if="unreadConvIds?.length > 0">{{ unreadConvIds.length }}</span></sup
        ></router-link
    >
    <Popover placement="bottom-middle" className="p-2 central-background" v-if="unreadConvIds.length > 0">
        <ul class="nav list-group list-group-flush ps-0" id="Messages_List">
            <li
                v-for="message in getAllUnreadConvs"
                :key="message.id"
                class="nav-item list-group-item message-list-item m-0"
                @click="handleMenuSelection(message)"
            >
                <div class="d-flex align-items-center">
                    <AvaInitials classes="me-1" :initialsType="message.conversationType" :user="message.users[0]" />
                    <div class="ms-2 flex-grow-1">
                        <div class="d-flex align-items-start">
                            <h6 class="me-auto mb-1 flex-grow-1">
                                <span v-if="message?.title?.length > 0"> {{ message.title }} </span>
                                <span v-else-if="message?.users?.length">
                                    {{ formatDisplayUsers(message.users) }}
                                </span>
                            </h6>
                            <small class="text-muted">
                                {{ formatDateToLocalBasedOnDayMode(message.modifiedOn, true) }}
                            </small>
                        </div>
                        <div class="d-flex align-items-center">
                            <div
                                :class="`${
                                    message.unread > 0 ? 'fw-semibold' : 'text-muted'
                                } me-auto flex-grow-1 align-self-start unread-text`"
                                v-html="sanitizeMarkup(markdownToHtml(message.text))"
                            ></div>
                            <div class="d-flex align-items-center">
                                <span v-if="message?.isCurrentUserTagged" class="text-danger fw-bold pe-1 font-size-md"
                                    >@</span
                                >
                                <div v-if="message.isImportant" class="mx-1 text-danger">
                                    <i class="fas fa-exclamation"></i>
                                </div>
                                <b :class="`unread-count ${message.unread > 0 ? '' : 'd-none'}`">
                                    {{ message.unread }}
                                </b>
                            </div>
                        </div>
                    </div>
                </div>
            </li>
        </ul>
    </Popover>
</template>

<style src="./MessagesPreview.scss"></style>
<script lang="ts" src="./MessagesPreview.ts"></script>
